// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as RssRouteImport } from './routes/rss'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as JoinRouteImport } from './routes/join'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AdvertisingRouteImport } from './routes/advertising'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as CategorySplatRouteImport } from './routes/category.$'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const RssRoute = RssRouteImport.update({
            id: '/rss',path: '/rss',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AdvertisingRoute = AdvertisingRouteImport.update({
            id: '/advertising',path: '/advertising',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PTokenRoute = PTokenRouteImport.update({
            id: '/p/$token',path: '/p/$token',getParentRoute: () => rootRouteImport
          })
const CategorySplatRoute = CategorySplatRouteImport.update({
            id: '/category/$',path: '/category/$',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdvertisingRoute: AdvertisingRoute,ContactRoute: ContactRoute,DisclaimerRoute: DisclaimerRoute,JoinRoute: JoinRoute,PrivacyRoute: PrivacyRoute,RssRoute: RssRoute,SitemapRoute: SitemapRoute,TermsRoute: TermsRoute,ArticlesSlugRoute: ArticlesSlugRoute,CategorySplatRoute: CategorySplatRoute,PTokenRoute: PTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)